import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import type { FontSchemaType } from "../../font";
import type { Distribution, QuickActionsChipType } from "../../types";
import { useDevice } from "../../useDevice";
import BottomFab from "../BottomFab";
import Box from "../Box";
import { CustomAppBar } from "../CustomAppbar";
import type { CustomAppBarProps } from "../CustomAppbar/types";
import type { Stat } from "../RowStats";
import ScrollContainer from "../ScrollContainer";
import StudyPackView from "./StudyPackView";
import type { SectionTag } from "./TagsSectionList";

const StudyPackApplet = ({
	renderNestedExamChips,
	distribution,
	productTitle,
	productImage,
	sectionTags,
	handleNavigateToIAP,
	handleQuickActionPress,
	bottomFab,
	stats,
	actionChips,
	handleClickListItem,
	appFont,
	customAppBar,
}: {
	renderNestedExamChips?: () => React.ReactNode;
	stats?: Stat[];
	distribution: Distribution;
	productTitle: string;
	productImage: string;
	sectionTags: SectionTag[];
	handleNavigateToIAP: () => void;
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
	bottomFab: {
		icon: string;
		label: string;
		onPress: () => void;
	};
	actionChips: QuickActionsChipType[];
	handleClickListItem: (selectedTagId: number, locked?: boolean) => void;
	appFont?: FontSchemaType;
	handleFeedbackNavigation: (toggleShowFeedbackDialog: () => void) => void;
	customAppBar: CustomAppBarProps;
}) => {
	const inset = useSafeAreaInsets();

	const { isMobile } = useDevice();
	const isWeb = Platform.OS === "web";
	const Wrapper = isWeb ? ScrollContainer : Box;

	return (
		<>
			<CustomAppBar {...customAppBar} />

			<Wrapper
				style={{
					flexGrow: 1,
					paddingHorizontal: isMobile ? 0 : 16,
				}}
				maxWidth="sm"
				// biome-ignore lint/a11y/useSemanticElements: <explanation>
				role="main"
			>
				{renderNestedExamChips?.()}
				<StudyPackView
					distribution={distribution}
					productTitle={productTitle}
					productImage={productImage}
					actionChips={actionChips}
					stats={stats}
					sectionTags={sectionTags}
					handleNavigateToIAP={handleNavigateToIAP}
					handleQuickActionPress={handleQuickActionPress}
					handleClickListItem={handleClickListItem}
					appFont={appFont}
				/>

				{isMobile && (
					<BottomFab
						icon={bottomFab.icon}
						bottom={inset.bottom}
						label={bottomFab.label}
						onPress={bottomFab.onPress}
					/>
				)}
			</Wrapper>
		</>
	);
};

export default StudyPackApplet;
